<template>
  <div class="faq-item-wrap" data-reveal>
    <div class="faq-item" :class="{ open: isOpen }">
      <button class="faq-question" @click="isOpen = !isOpen" :aria-expanded="isOpen">
        <span>{{ question }}</span>
        <span class="icon" aria-hidden="true">
          <span class="icon-line horizontal"></span>
          <span class="icon-line vertical"></span>
        </span>
      </button>
      <div class="faq-answer">
        <div class="faq-answer-inner">
          <p>{{ answer }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, ref } from "vue"

defineProps(["question", "answer"])

const isOpen = ref(false)
</script>

<style scoped>
.faq-item-wrap {
  margin-bottom: 1rem;
}

.faq-item {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: 0.4rem 1.75rem;
  transition: border-color var(--transition), box-shadow var(--transition);
}

.faq-item.open {
  border-color: var(--accent);
  box-shadow: var(--shadow-sm);
}

.faq-question {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1.5rem;
  font-family: var(--font-heading);
  font-weight: 700;
  font-size: 1rem;
  color: var(--ink);
  cursor: pointer;
  padding: 1.25rem 0;
  background: none;
  border: none;
  text-align: left;
}

.icon {
  position: relative;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.icon-line {
  position: absolute;
  top: 50%;
  left: 50%;
  background: var(--primary);
  border-radius: var(--radius-pill);
  transform: translate(-50%, -50%);
  transition: transform var(--transition), background var(--transition);
}

.icon-line.horizontal {
  width: 14px;
  height: 2px;
}

.icon-line.vertical {
  width: 2px;
  height: 14px;
}

.open .icon-line {
  background: var(--accent-dark);
}

.open .icon-line.vertical {
  transform: translate(-50%, -50%) rotate(90deg);
  opacity: 0;
}

.faq-answer {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.35s var(--ease);
}

.open .faq-answer {
  grid-template-rows: 1fr;
}

.faq-answer-inner {
  overflow: hidden;
}

.faq-answer-inner p {
  padding-bottom: 1.5rem;
  color: var(--body-text);
  line-height: 1.75;
  font-size: 0.95rem;
}

@media (max-width: 768px) {
  .faq-item {
    padding: 0.25rem 1.25rem;
  }

  .faq-question {
    font-size: 0.92rem;
  }
}
</style>
